/**
 * Türkçe sözlük · donemsel: Dönemsel Getiri ekranı
 * (`screens/DonemselAnalizScreen.tsx`) ve hazır periyotlar
 * (`lib/donemselTercih.ts`). Şekli bu dosya tanımlar; öteki diller ona bağlıdır.
 */
export const donemsel = {
  baslik: "Dönemsel Getiri",
  aciklama: "Seçilen varlıkların, seçilen dönemde, her gün o günde biten periyottaki yüzde getirisi.",
  tercihlerOkunuyor: "Tercihler okunuyor…",
  sunucuyaBagliDegil: "Sunucuya bağlı değil.",

  kilit: {
    ucretsiz: (n: number) => `${n} varlıktan fazlası, kıyas serileri ve sepet`,
    kendi: "Kendi varlıklarınız dışındaki varlıklar, kıyas serileri ve sepet",
    kisildi: "Kayıtlı seçiminiz silinmedi; şimdilik sınıra göre kısaltıldı.",
    sepet: "Sepet",
  },

  /** Hazır getiri periyotları (`PERIYOTLAR`). */
  periyot: {
    g7: "1 hafta (7 gün)",
    g30: "1 ay (30 gün)",
    g92: "3 ay (92 gün)",
    g182: "6 ay (182 gün)",
    g365: "1 yıl (365 gün)",
    g730: "2 yıl (730 gün)",
    g1095: "3 yıl (1095 gün)",
    g1460: "4 yıl (1460 gün)",
    g1825: "5 yıl (1825 gün)",
  },

  dengeleme: {
    yok: "Yok — al ve tut",
    aylik: "Her ay",
    ceyreklik: "Her çeyrek",
    yillik: "Her yıl",
  },

  liste: {
    baslik: "Varlıklar",
    seciliSayisi: (n: number, enCok: number) => `· ${n} / ${enCok} seçili`,
    gizle: "Gizle ▲",
    goster: "Göster ▼",
    okunamiyor: "Liste okunamıyor",
    yukleniyor: "Sunucudaki varlık listesi okunuyor…",
    okunamadi: "Varlık listesi okunamadı",
    ara: "Ara",
    araIpucu: "Sembol ya da ad",
    secimiTemizle: "Seçimi temizle",
    dolu: (n: number) => `En çok ${n} varlık seçilebilir; yenisi için birini bırakın.`,
    bos: "Sunucu henüz hiçbir varlığı izlemiyor.",
    uyanYok: "Aramaya uyan varlık yok.",
    kiyasGrubu: "Kıyas serileri",
    hazirlaniyorBalon: (ad: string) => `${ad} — hazırlanıyor`,
    hazirlaniyor: " hazırlanıyor",
  },

  doldur: {
    baslik: "Hesaplardan doldur",
    altBaslik: "· varlıkları ve sepet oranlarını bugünkü değerlerden",
    sanal: "sanal",
    hesaplaniyor: "Hesaplanıyor…",
    secVeOranla: "Seç ve oranla",
    hata: "Hesaplardan doldurulamadı",
    varlikYok: "Seçilen hesaplarda Dönemsel Getiri'de çizilebilecek varlık yok.",
    secildiSepetli: (n: number) => `${n} varlık seçildi, sepet oranları yazıldı.`,
    secildiTek: (n: number) => `${n} varlık seçildi (sepet için en az iki gerekir).`,
    disarida: "Dışarıda:",
  },

  ayarlar: {
    bolge: "Dönem ve seçenekler",
    paraBirimi: "Para birimi",
    periyot: "Getiri periyodu",
    ozelPeriyot: "Özel (gün sayısı)",
    gun: "Gün",
    tamSayiAraligi: (en: number, enCok: number) => `${en}–${enCok} arası tam sayı`,
    temettu: "Temettüler yeniden yatırılsın",
    sepetCiz: "Sepet getirisini de çiz",
    yalnizSepet: "Yalnızca sepeti göster",
    ortalamaEtiket: "Ortalama fiyat: son",
    ortalamaGirdi: "Ortalama fiyat gün sayısı",
    islemGunu: "işlem günü",
  },

  sepet: {
    enAzIki: "Sepet için kıyas serisi dışında en az iki varlık seçin.",
    dengeleme: "Dengeleme",
    esitDagit: "Eşit dağıt",
    kiyasGirmez: "Kıyas serileri sepete girmez; grafikte sepetle kıyas için durur.",
    gecersiz: "Oranlardan biri geçersiz: en fazla iki ondalıklı, 0 ile 100 arası bir yüzde girin.",
    toplamTam: "Toplam %100.",
    toplamEksik: (yuzde: string) => `Toplam %${yuzde}; sepet ancak toplam %100 olunca çizilir.`,
    olcekle: "100'e ölçekle",
  },

  istek: {
    varlikSec: "Yukarıdaki listeden en az bir varlık seçin.",
    ikiTarih: "İki tarihi de seçin.",
    sira: "Başlangıç tarihi bitişten sonra olamaz.",
    enCokGun: (n: number) => `Aralık en çok ${n} gün olabilir.`,
    paraSec: "Para birimini seçin.",
    sepetToplam: "Sepet oranlarının toplamı %100 olmalı (yukarıda).",
  },

  analiz: {
    uyariFiyat: (mesaj: string) => `fiyat: ${mesaj}`,
    uyariKur: (mesaj: string) => `kur: ${mesaj}`,
    derlemedeYok: "Bu derlemede Dönemsel Analiz yok.",
    sepet: "Sepet",
    secimBekleniyor: "Grafik için seçim bekleniyor",
    hesaplanamadi: "Analiz hesaplanamadı",
    esitleniyor: "Fiyatlar ve kurlar sunucudan alınıyor…",
    hesaplaniyor: "Hesaplanıyor…",
    guncelleniyor: "Güncelleniyor…",
    kismiBaslik: "Sunucudan bir kısmı alınamadı",
    kismiMetin: (ayrinti: string) => `Grafik bu cihazda zaten olan verilerle çizildi. Ayrıntı: ${ayrinti}`,
  },

  sonuc: {
    sepet: "Sepet",
    gunYokBaslik: "Çizilecek gün yok",
    gunYokAciklama: "Sepetin en genç varlığının verisi seçilen aralığın sonundan sonra başlıyor.",
    /** Grafik başlığı: gövde + (isteğe bağlı) ortalama + temettü + kapanış. */
    baslik: (periyot: number, para: string) => `${periyot} günlük getiri (${para}`,
    baslikOrtalama: (gun: number) => `, ortalama fiyat: son ${gun} işlem günü`,
    baslikTemettu: ", temettü dahil",
    baslikSon: ")",
    gecBaslik: "Grafik geç başlıyor",
    gecBaslikMetin: (tarih: string) =>
      `Sepetteki en genç varlığın verisi ${tarih} tarihinde başlıyor; grafik o günden itibaren çizildi.`,
  },

  sicrama: {
    baslik: "Olağan dışı fiyat sıçraması",
    kapanis: "kapanış",
    birIslemGunu: ", bir işlem gününde",
    olayDuzeltilmemis: "Kaynakta bu tarihte bölünme kaydı var ama fiyat ona göre düzeltilmemiş görünüyor.",
    olayYok: "Kaynakta bu tarihte bölünme ya da bedelsiz kaydı yok.",
    olayBilinmiyor: "Bu araç için şirket olayı bilgisi yok.",
    yaniltici: "Bu günü kapsayan periyotların getirisi yanıltıcı olabilir.",
    isaretBalon: (ad: string, tarih: string) => `${ad} ${tarih}: olağan dışı fiyat sıçraması`,
  },

  uc: {
    ortKapanis: (fiyat: string) => `ort. kapanış ${fiyat}`,
    ortGunler: (gun: number, from: string, to: string) => `${gun} işlem günü ${from}–${to}`,
    kapanis: (fiyat: string) => `kapanış ${fiyat}`,
    fiyatGunu: (tarih: string) => `fiyat günü ${tarih}`,
    birim: (birim: string) => `birim ${birim} (temettüyle)`,
  },

  seciliGun: {
    bolge: "Seçili gün",
    periyotSonu: (tarih: string) => `Periyot sonu ${tarih}`,
    periyotBasiAciklama: (tarih: string, gun: number) => `· periyot başı ${tarih} (${gun} gün önce)`,
    varlik: "Varlık",
    sutunBasi: "Periyot başı",
    sutunSonu: "Periyot sonu",
    getiri: "Getiri",
    sepetEndeks: "Sepetin değeri bir endekstir: kurulduğu gün 100.",
  },

  motorSoylemedi: "Motor bu değerin niçin olmadığını söylemedi — bu bir kusurdur, bildirin.",

  ozet: {
    bolge: "Özet",
    baslik: (periyot: number) => `Özet — ${periyot} günlük getirilerin dönem içindeki dağılımı`,
    varlik: "Varlık",
    son: "Son",
    enDusuk: "En düşük",
    enYuksek: "En yüksek",
    ortalama: "Ortalama",
    olculenGun: "Ölçülen gün",
  },

  bilgiKutusu: {
    periyotBasi: (tarih: string, para: string) => `periyot başı ${tarih} · ${para}`,
  },
};
